import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import SubscriptionPackageForm from './SubscriptionPackageForm';

// Rename the name of the function:
const SubscriptionPackageList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_subscription_package_list',
        defaultParams: { is_active: true },
        object: 'subscription_package'
    }
    const objectName = 'billing.subscription_package.object_name'
    const showSearch = false
    const isPaginated = false

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'key', label: 'billing.subscription_package.key_label' },
        { width: '3fr', field: 'name', label: 'billing.subscription_package.name_label' },
        { width: '1fr', field: 'feature_sync_status', label: 'billing.subscription_package.feature_sync_label', translationString: true },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'billing.subscription_package.active_packages_label',
            params: { 'is_active': true }
        },
        {
            id: 'inactive',
            label: 'billing.subscription_package.inactive_packages_label',
            params: { 'is_active': false }
        }
    ];

    // Specify form, detail modal or detailpage for this list
    const formModal = <SubscriptionPackageForm />;
    const onRowClick = 'editModal'

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            formModal={formModal}
            isPaginated={isPaginated}
            showDeleteOrDeactivate='flag_deactivated'
            allowEditingInactiveRows={true}
            onRowClick={onRowClick}
            filters={filters}
        />
    );
};

export default SubscriptionPackageList;